import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { Auth } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { PostCartaCobro } from '../../../store/actions/encargado-cia-action'
import BitacoraGestion from '../../bitacora-gestion-recuperador'
import { CarpetaDigitalComponent } from 'reccol-caso-general'

const Acciones = ({ formik, porConvenioOld, miRecobro, setActionButton }) => {  
  const history =useNavigate()
  const { rutUsuario } = Auth.currentUser()

  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));

  const dispatch = useDispatch()
  const [requisitosSelected, setRequisitos] = useState([])
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [showBitacora, setShowBitacora] = useState(false)
  const [showCarpeta, setShowCarpeta] = useState(false)
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {
    requisitosSeleccionados,
    requisitos,
    liquidacionPerdida,
    casoImplicado,
    llaves,
    cfg_form8,
    respuestaCarta
  } = data_encargado_cia

  const handleCloseBitacora = () => {
    setShowBitacora(false)
  }
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)
  const handleShowBitacora = () => setShowBitacora(true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => {
    setShow1(false)
    history('/area-trabajo-recupero-companias',{state:{queryState}})
  }
  const handleShow1 = () => setShow1(true)
  useEffect(() => {
    setRequisitos(requisitosSeleccionados && requisitosSeleccionados)
  }, [requisitosSeleccionados])
  const getResult = function (a1, a2) {
    var i = a1.length
    if (i != a2.length) return false

    while (i--) {
      if (a1[i] !== a2[i]) return false
    }
    return true
  }
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0
  }

  const handleValida = (e) => {
    if (!isObjEmpty(formik.errors)) {
      e.preventDefault()
    } else {
      const data = { ...formik.values }
      data['enviaCarta'] = 1
      data['moneda'] =
        liquidacionPerdida &&
        liquidacionPerdida.liquidacionPerdida['codMonedaPago']
      delete data.montoRecobro
      data['idCaso'] = llaves && llaves['idCaso']
      data['idImplicadoCaso'] = llaves && llaves['idImplicado']
      data['idOrganizacion'] = llaves && llaves['idOrgCaso']
      data['porcConvenioOld'] = porConvenioOld
      data['destinatarioCia'] =
        casoImplicado && casoImplicado.casoImplicado[0]['MontoCosto']
      data['montoCosto'] =
        liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
          ? liquidacionPerdida.liquidacionPerdida['mtoSalvataje'] !== null &&
            liquidacionPerdida.liquidacionPerdida['mtoPago'] !== null
            ? parseInt(
                liquidacionPerdida.liquidacionPerdida['mtoPago'] -
                  liquidacionPerdida.liquidacionPerdida['mtoSalvataje']
              )
            : liquidacionPerdida.liquidacionPerdida['mtoPago']
          : ''
      data['montoRecobro'] = miRecobro
      data['idUsuario'] = rutUsuario && rutUsuario

      
    }
  }
  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-carta {
      background-color:  #2E6EA5;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-carta:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;

    }
    .btn-actualizar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}
            
          />     
     
    </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Revise los Requisitos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Falta algún requisito obligatorio. Se requiere completar requisito(s)
          o indicar “Motivo Excepción"
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>Respuesta de la información enviada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {respuestaCarta
            ? respuestaCarta.respuestaCarta['message']
            : 'Enviando...'}
        </Modal.Body>
        {respuestaCarta && (
          <Modal.Footer>
            <Button variant='primary' onClick={handleClose1}>
              Aceptar
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      <BitacoraGestion
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />
      <Row>
      <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info' onClick={() => history('/area-trabajo-recupero-companias',{state:{queryState}})}>
            {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-btn-volver']}
          </Button>
          <Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
            {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-btn-carpeta']}
          </Button>
          <Button className='m-2' variant='carta' onClick={() => setActionButton('verActLiquidacion')} type='onSubmit' name='verActLiquidacion'>
            {cfg_form8 &&
              cfg_form8.cfg_form8['preparacartacobro-btn-act-liquidacion']}
          </Button>
          <Button className='m-2' variant='bitacora' onClick={handleShowBitacora}>
            {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-btn-bitacora']}
          </Button>
          <Button className='m-2' variant='actualizar' onClick={() => setActionButton('Actualizar')} type='onSubmit' name='actualizar'>
            {cfg_form8 &&
              cfg_form8.cfg_form8['preparacartacobro-btn-actualizar']}
          </Button>
          <Button className='m-2' variant='carta' onClick={() => setActionButton('EnviarCarta')} type='onSubmit' name='enviarCarta'>
            {cfg_form8 &&
              cfg_form8.cfg_form8['preparacartacobro-btn-enviacarta']}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default Acciones
